import { paymentStatusesEl } from './statuses'
import { cancellationReasonsEl } from './cancellationReasons'

export const translationEl = {
  ...paymentStatusesEl,
  ...cancellationReasonsEl,
  // Company Code Form
  welcome: 'Καλωσορίσατε',
  companyCodeInfo:
    'Εισάγετε τον κωδικό πρόσβασης της εταιρείας σας για να δημιουργήσετε μια νέα αναφορά ή ελέγξτε την κατάσταση μιας αναφοράς που έχει ήδη υποβληθεί.',
  companyCodeLabel: 'Κωδικός πρόσβασης',
  companyCodeInputPlaceholder:
    'Εισάγετε τον κωδικό πρόσβασης για μια νέα αναφορά',
  companyCodeNotFound:
    'Δεν βρέθηκε εταιρεία με αυτόν τον κωδικό. Ελέγξτε τον και δοκιμάστε ξανά.',
  statusOfExistingReport: 'Κατάσταση υπάρχουσας αναφοράς',
  createNewReport: 'Δημιουργία νέας αναφοράς',
  companyCode: 'Κωδικός εταιρείας',

  // Access Report Modal
  accessReportModalTitle: 'Για την πρόσβαση απαιτείται μοναδικός κωδικός',
  accessReportModalText:
    'Τη στιγμή που υποβάλατε την αναφορά σας δόθηκε ένας μοναδικός κωδικός. Επικολλήστε τον κωδικό στο πεδίο εισαγωγής παρακάτω.',
  accessReportModalLabel: 'Μοναδικός Κωδικός',
  accessReportModalPlaceholder: 'Εισάγετε τον κωδικό πρόσβασης',
  accessReportModalCancelBtn: 'Άκυρο',
  accessReportModalChecklBtn: 'Έλεγχος αναφοράς',

  // Save Token Modal
  saveTokenTitle: 'Η αναφορά υποβλήθηκε. Αποθηκεύστε τον παρακάτω κωδικό:',
  saveTokenImportant: 'ΣΗΜΑΝΤΙΚΟ:',
  saveTokenImportantNote:
    'Αποθηκεύστε τον παρακάτω κωδικό με ασφάλεια. Μην κοινοποιείτε τον κωδικό σε κανέναν. Με αυτόν τον κωδικό θα έχετε πρόσβαση στην αναφορά σας για να παρακολουθείτε την πρόοδό της και να βλέπετε τα μηνύματα.',
  saveTokenUniqueCodeLabel: 'Ο Μοναδικός σας Κωδικός',
  saveTokenReceivedReport:
    'Λάβαμε την αναφορά σας και θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατό.',
  saveTokenReportInfo:
    'Μπορείτε να κάνετε λήψη/εξαγωγή της αναφοράς που υποβάλατε ή να κάνετε κλικ στο "Ολοκλήρωση" για να προχωρήσετε.',
  saveTokenExportBtn: 'Εξαγωγή Αναφοράς',
  saveTokenCompleteBtn: 'Ολοκλήρωση',

  // Delete Resource Modal
  areYouSureWantToDelete:
    'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον χρήστη;',
  areYouSureWantToDeleteThisCategory:
    'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτήν την κατηγορία;',
  areYouSureWantToDeleteThisBranch:
    'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτο το Branch;',
  yesIamSure: 'Ναι, είμαι σίγουρος',
  noCancel: 'Όχι, ακύρωση',

  // Resolution Option Modal
  areYouSureWantToCloseThisCase:
    'Είστε σίγουροι ότι θέλετε να κλείσετε αυτήν την υπόθεση;',
  youAreAboutToCloseThisCase: 'Πρόκειται να κλείσετε την υπόθεση',
  theCaseWillBe: 'Η υπόθεση θα',
  howWouldYouLikeToResolveThisCase:
    'Πώς θα θέλατε να κλείσετε αυτήν την υπόθεση;',
  yesCloseTheCase: 'Ναι, κλείστε την υπόθεση',
  noIamNotReady: 'Όχι, δεν είμαι έτοιμος',
  archived: 'αρχειοθετηθεί',
  resolved: 'επιλυθεί',

  // Report Form
  reportAnOccurrenceText:
    'Χρησιμοποιήστε αυτήν τη φόρμα για να αναφέρετε περιστατικά παραπτωμάτων, απάτης ή παραβιάσεις συμμόρφωσης που αντιβαίνουν στις πολιτικές και τις διαδικασίες του οργανισμού. Η φόρμα ReportAll ζητά σχετικές πληροφορίες για να καθοριστεί εάν και πώς θα διεξαχθεί μια έρευνα. Η εμπιστευτικότητα προστατεύεται και οι υπεύθυνοι συμμόρφωσης είναι υποχρεωμένοι να προστατεύουν κάθε είδους προσωπικές πληροφορίες.',
  makeReport: 'Δημιουργία Αναφοράς',
  checkReport: 'Έλεγχος Αναφοράς',
  review: 'Ανασκόπηση',
  startReport: 'Έναρξη Αναφοράς',
  typeOfReport: 'Τύπος Αναφοράς',
  category: 'Κατηγορία',
  branch: 'Branch',
  fullName: 'Ονοματεπώνυμο',
  telephone: 'Τηλέφωνο',
  questions: 'Ερωτήσεις',
  whenDidTheIncidentOccur: 'Πότε συνέβη το περιστατικό;',
  isTheIncidentStillOngoing: 'Το περιστατικό συνεχίζεται ακόμα;',
  whereDidTheIncidentOccur: 'Που συνέβη το περιστατικό;',
  whoIsInvolvedAndWhatIsTheirCapacity:
    'Ποιοι εμπλέκονται και ποια είναι η ιδιότητά τους;',
  nameSurnameAndTheirCapacity: 'Όνομα, Επώνυμο και η ιδιότητά τους',
  fullDescriptionOfTheIncident: 'Πλήρης περιγραφή του συμβάντος',
  regular: 'Απλή',
  anonymous: 'Ανώνυμη',
  attachments: 'Συνημμένα',
  uploadFilesTitle:
    'Μπορείτε να ανεβάσετε οποιοδήποτε αρχείο σχετίζεται με την αναφορά σας',
  dragHere: 'Σύρετε εδώ για να μεταφορτώσετε αρχεία',
  supportedFiles: 'Αρχεία που υποστηρίζονται:',
  addFile: 'Προσθήκη Αρχείου',
  reportAnOccurrence: 'Αναφέρετε ένα περιστατικό',
  anonymousReporting: 'Ανώνυμη αναφορά',
  regularReporting: 'Απλή αναφορά',
  chooseIncidentcategory: 'Επιλέξτε κατηγορία περιστατικού',
  choose: 'Επιλέξτε',
  anonymousText:
    'Αυτή η Αναφορά είναι ανώνυμη, καθώς δεν απαιτεί προσωπικά δεδομένα ή/και στοιχεία επικοινωνίας από τον καταγγέλλοντα. Λάβετε υπόψη ότι σε αυτήν την περίπτωση, η παρακολούθηση της Αναφοράς σας επιτρέπεται μόνο μέσω του κωδικού πρόσβασης που σας παρέχεται κατά την υποβολή της Αναφοράς.',
  regularText:
    'Αυτή η Αναφορά ενδέχεται να ζητήσει τα προσωπικά σας δεδομένα ή/και τα στοιχεία επικοινωνίας πριν από την υποβολή. Σημειώστε ότι, εκτός από το όνομά σας, τέτοιες πληροφορίες δεν είναι υποχρεωτικές. Σε κάθε περίπτωση η αναφορά σας θα αντιμετωπίζεται με απόλυτη εμπιστευτικότητα.',
  optional: 'προαιρετικό',
  back: 'Πίσω',
  nextStep: 'Επόμενο βήμα',
  submitReport: 'Υποβολή',
  noAttachmentsFound: 'Δεν βρέθηκαν συνημμένα',
  yes: 'Ναι',
  no: 'Όχι',
  writeYourFullName: 'Γράψτε το όνομα σας',
  writeYourEmail: 'Γράψτε το email σας',
  writeYourTelephone: 'Γράψτε το τηλέφωνο σας',
  writeThePlaceOfTheIncident: 'Γράψτε τον τόπο του συμβάντος',
  addTheNamesOfThePeopleInvolved:
    'Προσθέστε τα ονόματα των ατόμων που εμπλέκονται',
  describeIncident:
    'Περιγράψτε το περιστατικό (Τι συνέβη; Πώς συνέβη; κ.λπ.) Να είστε όσο το δυνατόν πιο συγκεκριμένοι.',
  report: 'Αναφορά',
  export: 'Εξαγωγή',
  caseDetails: 'Λεπτομέρειες Υπόθεσης',
  yourMessages: 'Τα μηνύματά σας',
  yourMessagesInfo:
    'Εδώ μπορείτε να επικοινωνήσετε με τον υπεύθυνο συμμόρφωσης που αναλαμβάνει την υπόθεσή σας, για να προσθέσετε περισσότερες πληροφορίες σχετικά με την αναφορά σας.',
  textHere: 'Γράψτε εδώ',
  freeTextSmallField: 'Μικρό Κέιμενο',
  freeTextLargeField: 'Μεγάλο Κέιμενο',
  details: 'Λεπτομέρειες',
  assignTo: 'Ανάθεση σε',
  caseOverview: 'Επισκόπηση Υπόθεσης',
  activityLog: 'Καταγραφή Δραστηριότητας',
  submit: 'Υποβολή',
  search: 'Αναζήτηση',
  selectBranch: 'Επιλέξτε Branch',

  // Status Cases
  UNASSIGNED: 'Χωρίς ανάθεση',
  IN_PROGRESS: 'Σε εξέλιξη',
  CLOSED: 'Κλειστές',
  TOTAL: 'Σύνολο',

  // Navigation
  dashboard: 'Αρχική',
  reports: 'Αναφορές',
  users: 'Χρήστες',
  settings: 'Ρυθμίσεις',
  statistics: 'Στατιστικά',
  categories: 'Κατηγορίες',
  branches: 'Branches',

  // Admin
  newUser: 'Νέος χρήστης',
  editUser: 'Επεξεργασία χρήστη',
  saveNewUser: 'Αποθήκευση νέου χρήστη',
  userName: 'Όνομα χρήστη',
  firstName: 'Όνομα',
  lastName: 'Επώνυμο',
  password: 'Κωδικός',
  position: 'Θέση',
  language: 'Γλώσσα',
  newCategory: 'Νέα κατηγορία',
  newBranch: 'Νέο branch',
  editCategory: 'Επεξεργασία κατηγορίας',
  editBranch: 'Επεξεργασία branch',
  insertCategory: 'Εισάγετε κατηγορία',
  insertName: 'Εισάγετε όνομα',
  saveCategory: 'Αποθήκευση κατηγορίας',
  noCategoriesFound: 'Δεν βρέθηκαν κατηγορίες',
  noDataFound: 'Δεν βρέθηκαν δεδομένα',
  changePassword: 'Αλλαγή κωδικού',
  updateCompanyName: 'Ενημέρωση ονόματος',
  updatePrivacyPolicy: 'Ενημέρωση πολιτικής',
  enterLink: 'Εισάγετε σύνδεσμο',
  updateLogo: 'Ενημέρωση λογότυπου',
  companyLogo: 'Λογότυπο εταιρείας',

  // Compliance Officer
  complianceOfficer: 'Υπεύθυνος Συμμόρφωσης',
  visibility: 'Ορατότητα',
  created: 'Δημιουργήθηκε',
  status: 'Κατάσταση',
  overviewStatistics: 'Επισκόπηση Στατιστικών',
  complianceOfficerNotes: 'Σημειώσεις Υπευθύνου Συμμόρφωσης',
  complianceOffcerNoteCreatedBy:
    'Σημείωση Υπεύθυνου Συμμόρφωσης δημιουργήθηκε από:',
  youHaventAddedNotes:
    'Δεν έχετε προσθέσει ακόμη σημειώσεις σε αυτήν την υπόθεση.',
  onlyAssignedCoOfficerCanViewMessages:
    'Μόνο ο αρμόδιος Υπεύθυνος Συμμόρφωσης μπορεί να δει τα μηνύματα.',
  characterLimit: 'Όριο χαρακτήρων',
  noteLimit: 'Το μήνυμα πρέπει να έχει το πολύ 320 χαρακτήρες',
  closeCase: 'Κλείσιμο υπόθεσης',
  resolutionOption: 'Επιλογή Απόφασης',
  archivedClosed: 'Αρχείο (Κλειστή)',
  resolvedClosed: 'Απόφαση (Κλειστή)',
  caseClosed: 'Υπόθεση Κλειστή',
  REPORT_CREATED: 'Αναφορά Δημιουργήθηκε',
  COMPLIANCE_OFFICER_ASSIGNED: 'Υπεύθυνος Συμμόρφωσης Ανατέθηκε:',
  REPORT_STATUS_CHANGED: 'Κατάσταση Αναφοράς Αλλάχθηκε:',
  REPORT_NOTE_CREATED: 'Σημείωση Αναφοράς δημιουργήθηκε',
  REPORT_EDITED: 'Αναφορά Επεξεργάστηκε',

  // Table
  showing: 'Εμφάνιση',
  to: 'έως',
  entries: 'καταχωρήσεις',
  of: 'από',
  pages: 'σελίδες',
  ANONYMOUS: 'Ανώνυμη',
  noReportsFound: 'Δεν βρέθηκαν αναφορές',
  noUsersFound: 'Δεν βρέθηκαν χρήστες',

  // Charts
  mostReportedCategories: 'Οι πιο αναφερόμενες κατηγορίες',
  conclusionType: 'Τύπος συμπερασμάτων',
  numberNatureOfReports: 'Αριθμός / Φύση Αναφορών',
  total: 'Όλες οι αναφορές',
  other: 'Υπόλοιπες',
  noDataFoundForTheSelectedPeriod:
    'Δεν βρέθηκαν δεδομένα για την επιλεγμένη περίοδο',

  // Toast messages
  copiedToClipboard: 'Αντιγράφηκε στο πρόχειρο',
  aUserWithThisEmailAlreadyExists: 'Υπάρχει ήδη ένας χρήστης με αυτό το email',
  aUserWithThisUsernameAlreadyExists:
    'Υπάρχει ήδη ένας χρήστης με αυτό το όνομα χρήστη',
  failedToCreateUser: 'Αποτυχία δημιουργίας χρήστη',
  userHasBeenCreated: 'Ο χρήστης δημιουργήθηκε',
  userHasBeenUpdated: 'Ο χρήστης ενημερώθηκε',
  failedToUpdateUser: 'Αποτυχία ενημέρωσης χρήστη',
  userHasBeenDeleted: 'Ο χρήστης διαγράφηκε',
  failedToDeleteUser: 'Αποτυχία διαγραφής χρήστη',
  failedToSubmitNote: 'Αποτυχία υποβολής σημείωσης',
  failedToLoadReports: 'Αποτυχία φόρτωσης αναφορών',
  failedToCreateCategory: 'Αποτυχία δημιουργίας κατηγορίας',
  categoryHasBeenCreated: 'Η κατηγορία δημιουργήθηκε',
  categoryHasBeenDeleted: 'Η κατηγορία διαγράφηκε',
  failedToDeleteCategory: 'Αποτυχία διαγραφής κατηγορίας',
  categoryHasBeenUpdated: 'Η κατηγορία ενημερώθηκε',
  branchHasBeenUpdated: 'Tο branch ενημερώθηκε',
  failedToUpdateBranch: 'Αποτυχία ενημέρωσης branch',
  branchHasBeenDeleted: 'Το branch διαγράφηκε',
  failedToDeleteBranch: 'Αποτυχία διαγραφής branch',
  categoryHasAttachedReports_one:
    'Δεν μπορεί να διαγραφεί: {{count}} αναφορά ανήκει σε αυτήν την κατηγορία.',
  categoryHasAttachedReports_other:
    'Δεν μπορεί να διαγραφεί: {{count}} αναφορές ανήκουν σε αυτήν την κατηγορία.',
  branchHasAttachedReports_one:
    'Δεν μπορεί να διαγραφεί: {{count}} αναφορά ανήκει σε αυτό το branch.',
  branchHasAttachedReports_other:
    'Δεν μπορεί να διαγραφεί: {{count}} αναφορές ανήκουν σε αυτό το branch.',
  attachedReportsUnknown:
    'Δεν είναι διαθέσιμο μέχρι να φορτώσει η λίστα αναφορών.',
  failedToUpdateCategory: 'Αποτυχία ενημέρωσης κατηγορίας',
  branchHasBeenCreated: 'Tο branch δημιουργήθηκε',
  failedToCreateBranch: 'Αποτυχία δημιουργίας branch',
  caseHasBeenClosed: 'Η υπόθεση έκλεισε',
  failedToCloseCase: 'Αποτυχία κλεισίματος υπόθεσης',
  yourPasswordHasBeenResetsussfully: 'Ο κωδικός σας επαναφέρθηκε επιτυχώς',
  submitFailed: 'Αποτυχία υποβολής',
  aResetLinkHasBeenSentToYourEmail:
    'Ένας σύνδεσμος επαναφοράς έχει σταλεί στο email σας.',
  InvalidUsernameOrPassword: 'Λανθασμένο όνομα χρήστη ή κωδικός',
  humanVerificationFailed:
    'Η επαλήθευση ασφαλείας απέτυχε. Παρακαλούμε δοκιμάστε ξανά.',
  failedToResetPassword: 'Αποτυχία επαναφοράς κωδικού',
  yourPasswordHasBeenChanged: 'Ο κωδικός σας άλλαξε επιτυχώς',
  failedToChangePassword: 'Αποτυχία αλλαγής κωδικού',
  companyNameHasBeenUpdated: 'Το όνομα εταιρείας άλλαξε επιτυχώς',
  failedToUpdateCompanyName: 'Αποτυχία αλλαγής όνομα εταιρείας',
  sessionExpired: 'Η συνεδρία σας έληξε. Παρακαλώ συνδεθείτε ξανά.',
  failedToSendMessage: 'Αποτυχία αποστολής μηνύματος',
  failedToLoadMessages: 'Αποτυχία φόρτωσης μηνυμάτων',
  privacyPolicyHasBeenUpdated: 'Η πολιτική απορρήτου άλλαξε επιτυχώς',
  failedToUpdatePrivacyPolicy: 'Αποτυχία αλλαγής πολιτικής απορρήτου',
  logoHasBeenUpdated: 'Το λογότυπο άλλαξε επιτυχώς',
  failedToUpdateLogo: 'Αποτυχία αλλαγής λογότυπου',
  caseAssigned: 'Η υπόθεση ανατέθηκε με επιτυχία',

  // Error messages
  somethingWentWrongFailedToLoadNotes:
    'Κάτι πήγε στραβά κατά την φόρτωση των σημειώσεων',

  //Validation messages
  requiredField: 'Υποχρεωτικό πεδίο',
  invalidEmail: 'Μη έγκυρο email',
  invalidPhone: 'Μη έγκυρο τηλέφωνο',

  logout: 'Αποσύνδεση',
  logIn: 'Σύνδεση',
  enterCredentials:
    'Εισαγάγετε τα διαπιστευτήριά σας για πρόσβαση στον λογαριασμό σας.',
  resetPassword: 'Επαναφορά κωδικού',
  forgotPassword: 'Ξεχάσατε τον κωδικό σας;',
  insertUsername: 'Εισάγετε όνομα χρήστη',
  insertPassword: 'Εισάγετε κωδικό',
  insertEmail: 'Εισάγετε email',
  enterYourEmailToResetYourPassword:
    'Εισάγετε το email σας για να επαναφέρετε τον κωδικό σας.',
  enterNewPassword: 'Εισάγετε νέο κωδικό πρόσβασης',
  confirmPassword: 'Επιβεβαίωση κωδικού',
  passwordMustBeAtLeast8CharactersAndContainAtLeastOneUppercaseLetterAndOneNumber:
    'Ο κωδικός πρέπει να είναι τουλάχιστον 8 χαρακτήρες και να περιέχει τουλάχιστον ένα κεφαλαίο γράμμα έναν αριθμό και έναν ειδικό χαρακτήρα.',
  passwordsMustMatch: 'Οι κωδικοί πρέπει να ταιριάζουν',

  'Select Position': 'Επιλέξτε θέση',
  'Compliance Officer': 'Υπεύθυνος Συμμόρφωσης',
  Administrator: 'Διαχειριστής',
  HR: 'HR',
  COMPLIANCE_OFFICER: 'Υπεύθυνος Συμμόρφωσης',
  ADMINISTRATOR: 'Διαχειριστής',

  chooseResolutionOption: 'Επιλέξτε Απόφαση',
  'Case Dismissed': 'Η υπόθεση απορρίφθηκε',
  Lawsuit: 'Αγωγή',
  'Report to Other Authorities': 'Αναφορά σε άλλες Αρχές',
  'Resolved Internally': 'Επιλύθηκε εσωτερικά',

  IhaveReadAndAgreeWithThe: 'Έχω διαβάσει και συμφωνώ με τους',
  iHaveReadAndUnderstoodThe: 'Έχω διαβάσει και συμφωνώ με τους',
  iHaveReadAndUnderstoodTheLicenseAgreement:
    'Έχω διαβάσει, κατανοήσει και αποδέχομαι πλήρως τη',
  endUserLicenseAgreement: 'Συμφωνία Άδειας Χρήσης',
  privacyPolicy: 'Πολιτική Απορρήτου',
  termsAndConditions: 'Όρους και Προϋποθέσεις',
  IhaveBeenInformedAboutTheProcessingOfMyData:
    'Έχω ενημερωθεί για την επεξεργασία των προσωπικών μου δεδομένων, σύμφωνα με την',
  privacyStatement: 'Δήλωση Προστασίας Προσωπικών Δεδομένων',

  Jan: 'Ιαν',
  Feb: 'Φεβ',
  Mar: 'Μαρ',
  Apr: 'Απρ',
  May: 'Μαι',
  Jun: 'Ιουν',
  Jul: 'Ιουλ',
  Aug: 'Αυγ',
  Sep: 'Σεπ',
  Oct: 'Οκτ',
  Nov: 'Νοε',
  Dec: 'Δεκ',

  CASE_DISMISSED: 'Yπόθεση απορρίφθηκε',
  LAWSUIT: 'Αγωγή',
  REPORT_TO_OTHER_AUTHORITIES: 'Αναφορά σε άλλες Αρχές',
  RESOLVED_INTERNALLY: 'Επιλύθηκε εσωτερικά',

  tooltipLogo:
    'Το λογότυπο της εταιρείας θα εμφανίζεται όταν ένας πληροφοριοδότης υποβάλλει μια αναφορά στην εταιρεία σας.',
  somethingWentWrongPleaseTryAgain:
    'Κάτι πήγε στραβά, παρακαλώ δοκιμάστε ξανά.',
  reviewPlan: 'Πλάνο',
  billing: 'Χρέωση',
  changePlan: 'Αλλαγή Πλάνου',
  next: 'Επόμενο',
  payNow: 'Πληρωμή',
  email: 'Email',
  username: 'Ονομα χρήστη',
  detailsDescription:
    'Εισάγετε τα στοιχεία σας. Μόλις ολοκληρωθεί η πληρωμή, θα δημιουργηθεί αυτόματα ένας λογαριασμός.',
  billingInformation: 'Πληροφορίες χρέωσης',
  billingInformationDescription:
    'Εισαγάγετε τα στοιχεία χρέωσής σας για να ολοκληρώσετε την πληρωμή. Το όνομα και η διεύθυνση εμφανίζονται στα τιμολόγιά σας. Θα μεταφερθείτε με ασφάλεια στη Stripe.',
  companyName: 'Ονομα εταιρείας',
  companyEmail: 'Email εταιρείας',
  companyTaxId: 'ΑΦΜ εταιρείας',
  country: 'Χώρα',
  state: '',
  city: 'Πόλη',
  postalCode: 'Ταχυδρομικός κώδικας',
  address1: 'Διεύθυνση 1',
  address2: 'Διεύθυνση 2',
  subscriptionEod: 'Λήξη συνδρομής',
  loginToYourAccount: 'Συνδεθείτε στον λογαριασμό σας',
  paymentSuccessTitle: 'Η πληρωμή σας ολοκληρώθηκε με επιτυχία',
  paymentSuccessText:
    'Λάβαμε την πληρωμή σας και σας στείλαμε ένα email με τα στοιχεία σύνδεσής σας.',
  planAndBilling: 'Συνδρομή',
  youAreOnThe: 'Είστε στο',
  membershipPlan: 'πλάνο συνδρομής',
  thisSubscriptionIsValidTill: 'Η συνδρομή σας ισχύει μέχρι',
  itWillAutomaticallyRenew:
    'Θα ανανεώνεται αυτόματα στο τέλος της περιόδου χρέωσης, εκτός εάν η συνδρομή ακυρωθεί εκ των προτέρων.',
  thePriceOfMembership: 'Η τιμή για την συνδρομή είναι',
  plusVat: '+ΦΠΑ',
  myPlan: 'Το πλάνο μου',
  myInvoices: 'Τα τιμολόγιά μου',
  cancelSubscription: 'Ακύρωση συνδρομής',
  reActivateSubscription: 'Επανενεργοποίηση συνδρομής',
  cancelSubscriptionDescription:
    'Είστε σίγουροι ότι θέλετε να ακυρώσετε τη συνδρομή σας; Θα παραμείνει ενεργή μέχρι το τέλος της περιόδου χρέωσης. Μπορείτε να την ενεργοποιήσετε ξανά ανά πάσα στιγμή πριν από το τέλος της περιόδου χρέωσης.',
  reactivateSubscriptionDescription:
    'Είστε σίγουροι ότι θέλετε να ενεργοποιήσετε ξανά τη συνδρομή σας; Μπορείτε να την ακυρώσετε ξανά ανά πάσα στιγμή πριν από τη λήξη της περιόδου χρέωσης.',
  subscriptionCancelled:
    'Η συνδρομή θα ακυρωθεί στο τέλος της περιόδου χρέωσης',
  subscriptionReactivated:
    'Η ακύρωση της συνδρομής έχει ανακληθεί. Η συνδρομή σας θα συνεχιστεί',
  // Cancellation feedback. The reason is required by us, not by the backend,
  // which accepts a cancellation without one - see ModalCancelSubscription.
  whyAreYouCancelling: 'Γιατί ακυρώνετε τη συνδρομή σας;',
  selectAReason: 'Επιλέξτε λόγο',
  anythingElseYouWouldLikeToTellUs: 'Θέλετε να μας πείτε κάτι ακόμη;',
  notGiven: 'Δεν δόθηκε',
  itWillBeCancelledAtTheEndOfTheBillingPeriod:
    'Θα ακυρωθεί στο τέλος της περιόδου χρέωσης.',
  chargeDate: 'Ημ/νια χρέωσης',
  billingPeriod: 'Διάστημα χρέωσης',
  amount: 'Ποσό',
  user: 'Χρήστης',
  company: 'Εταιρεία',
  personalInformationHasBeenUpdated:
    'Τα προσωπικά σας στοιχεία ενημερώθηκανί επιτυχώς',
  duplicateEmail:
    'Αυτή η διεύθυνση ηλεκτρονικού ταχυδρομείου χρησιμοποιείται ήδη',
  duplicateUsername: 'Αυτό το όνομα χρήστη χρησιμοποιείται ήδη',
  save: 'Αποθήκευση',
  edit: 'Επεξεργασία',
  delete: 'Διαγραφή',
  cancel: 'Ακύρωση',
  personalInformation: 'Προσωπικές πληροφορίες',
  general: 'Γενικά',
  security: 'Ασφάλεια',
  update: 'Ενημέρωση',
  companyProfile: 'Προφίλ εταιρείας',
  billingInformationHasBeenUpdated:
    'Τα στοιχεία χρέωσής σας ενημερώθηκαν επιτυχώς',
  yourPlan: 'Το πλάνο σας',
  expiresIn: 'Λήγει στις',
  youHaveSelectedThe: 'Έχετε επιλέξει το',
  month: 'μήνα',
  months: 'μήνες',
  yourUniversity: 'πανεπιστημίου',
  students: 'φοιτητών',
  employees: 'υπαλλήλων',
  upTo: 'μέχρι',
  upTo2: 'Μέχρι',
  moreThan: 'περισσότερους από',
  moreThan2: 'Περισσότερους από',
  seatsPlanDescription:
    'Αυτό το πρόγραμμα αφορά την εγγραφή {{range}} {{seats}} {{unit}} του {{productType}} σας.',
  myPlanDescription:
    'Αυτή η συνδρομή ισχύει για {{months}} {{monthsLabel}} και περιλαμβάνει: €{{price}} για {{months}} {{monthsLabel}} - μετά από αυτή την περίοδο, θα χρεώνεστε επαναλαμβανόμενα €{{price}} κάθε {{months}} {{monthsLabel}}, εκτός εάν η συνδρομή ακυρωθεί πριν από τη λήξη της περιόδου.',
  changePlanDescription:
    'Επιλέξτε το πρόγραμμα που ταιριάζει στις απαιτήσεις της επιχείρησής σας, ανάλογα με τις λειτουργίες που χρειάζεστε και τον αριθμό των υπαλλήλων/φοιτητών που απασχολεί ο οργανισμός σας. Η νέα περίοδος χρέωσης θα ξεκινήσει στο τέλος της τρέχουσας περιόδου χρέωσης.',
  selectYourPlanTitle: 'Επιλέξτε το πρόγραμμά σας',
  selectYourPlanDescription:
    'Επιλέξτε το πρόγραμμα που ταιριάζει στις απαιτήσεις της επιχείρησής σας ανάλογα με τις λειτουργίες που χρειάζεστε και τον αριθμό των υπαλλήλων / σπουδαστών που διαθέτει ο οργανισμός σας.',
  studentsUnit: 'φοιτητές',
  employeesUnit: 'εργαζομένους',
  companies: 'Εταιρείες',
  universities: 'Πανεπιστήμια',
  standardPlanTitle: 'Standard Πακέτο',
  monthly: 'Μηνιαία',
  yearly: 'Ετήσια',

  // Super admin cancellations table
  cancellations: 'Ακυρώσεις',
  plan: 'Πρόγραμμα',
  reason: 'Λόγος',
  comment: 'Σχόλιο',
  cancelledBy: 'Ακυρώθηκε από',
  cancelledOn: 'Ημερομηνία ακύρωσης',
  accessEnds: 'Λήξη πρόσβασης',
  allReasons: 'Όλοι οι λόγοι',
  allCancellations: 'Όλες οι ακυρώσεις',
  reversed: 'Αναιρέθηκε',
  stillStanding: 'Σε ισχύ',
  noCancellationsFound: 'Δεν βρέθηκαν ακυρώσεις',
  annually: 'Ετήσια',
  vatExclusive: 'χωρίς ΦΠΑ',
  featureFullAnonymity: 'Πλήρης Ανωνυμία',
  featureCompliance: 'Συμμόρφωση',
  featureLocalization: 'Γλώσσα',
  featureFollowUp: 'Ειδοποιήσεις',
  featureConfigurations: 'Ρυθμίσεις',
  featureUserRoles: 'Ρόλοι χρηστών',
  featureIdentityProtection: 'Προστασία ταυτότητας καταγγέλλοντος',
  featureReportsManagement: 'Διαχείριση Καταγγελιών & Καταγραφή',
  featureCustomLogo: 'Προσαρμοσμένο λογότυπο',
  featureCustomerSupport: 'Υποστήριξη πελατών',
  featureAttachments: 'Συνημμένα έγγραφα',
  getStartedButton: 'Ξεκινήστε',
  activePlan: 'Ενεργό πλάνο',
  cancelPlanUpdate: 'Ακύρωση αλλαγής πλάνου',
  planChangedSuccessfully: 'Το πλάνο άλλαξε με επιτυχία',
  failedToChangePlan: 'Αποτυχία αλλαγής πλάνου',
  planChangedCancelSuccessfully: 'Η αλλαγή πλάνου ακυρώθηκε με επιτυχία ',
  failedToCancelChangePlan: 'Αποτυχία ακύρωσης αλλαγής προγράμματος',
  allFieldsAreRequired: 'Όλα τα πεδία είναι υποχρεωτικά',
  allConsentsRequired:
    'Πρέπει να αποδεχτείτε τους Όρους και Προϋποθέσεις, την Πολιτική Απορρήτου και τη Συμφωνία Άδειας Χρήσης Τελικού Χρήστη.',
  pleaseFillAllTheRequiredFields:
    'Παρακαλώ συμπληρώστε όλα τα υποχρεωτικά πεδία',
  noCategoriesFoundInitial:
    'Δεν υπάρχουν ακόμη κατηγορίες. Δημιουργήστε πρώτα μία, ώστε οι χρήστες να μπορούν να δημιουργήσουν νέες αναφορές.',
  payment: 'Επιβεβαίωση',
  paymentInformation: 'Πληροφορίες πληρωμής',
  paymentInformationDescription:
    'Επιλέξτε τον τρόπο πληρωμής για να ολοκληρώσετε την αγορά σας. Για πληρωμή με κάρτα, θα μεταφερθείτε με ασφάλεια στο Stripe.',
  cardPayment: 'Πληρωμή με κάρτα',
  manualBankTransfer: 'Τραπεζική μεταφορά',
  organizations: 'Εταιρείες',
  transactions: 'Συναλλαγές',
  noOrganizationsFound: 'Δεν βρέθηκαν εταιρείες',
  active: 'Ένεργό',
  organization: 'Εταιρεία',
  subscription: 'Συνδρομή',
  paymentMethod: 'Τρόπος πληρωμής',
  subscriptionPeriod: 'Περίοδος συνδρομής',
  companyNameColumn: 'Επωνυμία εταιρείας',
  invoiceNo: 'Αρ. παραστατικού',
  method: 'Μέθοδος',
  card: 'Κάρτα',
  manualPayment: 'Χειροκίνητη πληρωμή',
  noTransactionsFound: 'Δεν βρέθηκαν συναλλαγές',
  selectDateRange: 'Επιλέξτε εύρος ημερομηνιών',
  viewTransactions: 'Προβολή συναλλαγών',
  activateAccount: 'Ενεργοποίηση λογαριασμού',
  updateEod: 'Ενημέρωση λήξης',
  updateEodDescription:
    'Ορίστε νέα ημερομηνία λήξης συνδρομής για αυτήν την εταιρεία.',
  accountActivatedSuccessfully: 'Ο λογαριασμός ενεργοποιήθηκε με επιτυχία',
  provisionalPeriod: 'προσωρινή',
  provisionalPeriodNote:
    'Προσωρινή περίοδος για μη επιβεβαιωμένο τραπεζικό έμβασμα. Η συνδρομή ξεκινά από την ημερομηνία επιβεβαίωσης της πληρωμής.',
  noSubscriptionToActivate:
    'Δεν βρέθηκε συνδρομή για αυτόν τον οργανισμό, οπότε δεν υπάρχει κάτι προς ενεργοποίηση.',
  failedToActivateAccount: 'Η ενεργοποίηση του λογαριασμού απέτυχε',
  subscriptionEodUpdated: 'Η ημερομηνία λήξης συνδρομής ενημερώθηκε',
  failedToUpdateSubscriptionEod:
    'Η ενημέρωση της ημερομηνίας λήξης συνδρομής απέτυχε',
  noOrganizationsUsersFound: 'Δεν βρέθηκαν χρήστες',
  pending: 'Σε εκκρεμότητα',
  download: 'Λήψη',
  view: 'Προβολή',
  expand: 'Ανάπτυξη',
  collapse: 'Σύμπτυξη',
  value: 'Τιμή',
  mailAddress: 'Διεύθυνση email',
  sendMessage: 'Αποστολή μηνύματος',
  support: 'Υποστήριξη',
  howCanWeHelpYou: 'Πώς μπορούμε να σας βοηθήσουμε;',
  supportFormTitle:
    'Συμπληρώστε την παρακάτω φόρμα για να ξεκινήσει η επικοινωνία.',
  supportFormDescription:
    'Η ομάδα υποστήριξης απαντά συνήθως εντός μίας εργάσιμης ημέρας.',
  subject: 'Θέμα',
  supportSubjectPlaceholder: 'Σχετικά με τι είναι το μήνυμά σας;',
  subjectMustBeAtLeast5Characters:
    'Το θέμα πρέπει να έχει τουλάχιστον 5 χαρακτήρες',
  messageMustBeAtLeast10Characters:
    'Το μήνυμα πρέπει να έχει τουλάχιστον 10 χαρακτήρες',
  supportMessageLabel:
    'Πείτε μας με τι χρειάζεστε βοήθεια και πώς μπορούμε να βοηθήσουμε',
  yourMessageHere: 'Το μήνυμά σας εδώ',
  supportMessageSent: 'Το μήνυμά σας στάλθηκε',
  failedToSendSupportMessage: 'Η αποστολή του μηνύματος απέτυχε',
  exit: 'Έξοδος',
  goToLogin: 'Μετάβαση στη σύνδεση',
  bankTransferSentTitle:
    'Στάλθηκε email στην καταχωρημένη διεύθυνση της εταιρείας.',
  bankTransferSentDescription:
    'Ακολουθήστε τις οδηγίες του email και ολοκληρώστε την πληρωμή το συντομότερο δυνατό. Ο λογαριασμός σας ReportAll θα ενεργοποιηθεί μόνο μετά τη λήψη της πληρωμής. Μπορείτε να βλέπετε τη συνδρομή και τις ρυθμίσεις σας, αλλά η πλήρης πρόσβαση θα είναι διαθέσιμη μετά την ενεργοποίηση.',
  planUpdateNotActiveBanner:
    'Η ενημέρωση του πλάνου ReportAll δεν είναι ακόμη ενεργή. Θα επικοινωνήσουμε μαζί σας μόλις ληφθεί η πληρωμή σας και ενεργοποιηθεί το νέο σας πλάνο συνδρομής.',
  accountNotActivatedBanner:
    'Η ενεργοποίηση του λογαριασμού σας ReportAll δεν έχει ολοκληρωθεί. Πραγματοποιήστε την πληρωμή σας και ενημερώστε μας για να επιβεβαιώσουμε την ενεργοποίηση.',
  accountAwaitingActivationAdmin:
    'Ο λογαριασμός σας αναμένει ενεργοποίηση. Επιβεβαιώστε την πληρωμή σας για να αποκτήσετε πλήρη πρόσβαση.',
  disabledUntilActivation:
    'Δεν είναι διαθέσιμο μέχρι να ενεργοποιηθεί ο λογαριασμός σας.',
  confirmPayment: 'Επιβεβαίωση πληρωμής',
  paymentOptions: 'Επιλογές πληρωμής',
  managePaymentMethod: 'Διαχειριστείτε τον τρόπο πληρωμής σας.',
  showSubscriptionBankDetails: 'Εμφάνιση τραπεζικών στοιχείων συνδρομής',
  hideSubscriptionBankDetails: 'Απόκρυψη τραπεζικών στοιχείων συνδρομής',
  accountAwaitingActivation:
    'Ο οργανισμός σας αναμένει ενεργοποίηση. Επικοινωνήστε με τον διαχειριστή σας.',
  invoiceHistoryNote:
    'Το ιστορικό τιμολογίων είναι διαθέσιμο μέσω του λογαριασμού μόνο για τα προηγούμενα 3 έτη. Επικοινωνήστε με την υποστήριξη πελατών αν θέλετε πρόσβαση σε παλαιότερο ιστορικό.',
  noInvoicesFound: 'Δεν βρέθηκαν τιμολόγια',
  paymentConfirmationSent: 'Η επιβεβαίωση πληρωμής στάλθηκε',
  failedToConfirmPayment: 'Η αποστολή επιβεβαίωσης πληρωμής απέτυχε',
  tryAgain: 'Δοκιμάστε ξανά',
  failedToLoadInvoices: 'Η φόρτωση των τιμολογίων απέτυχε',
  failedToLoadPlan: 'Η φόρτωση του πλάνου σας απέτυχε',
  noActiveSubscription: 'Δεν βρέθηκε ενεργή συνδρομή',
  confirm: 'Επιβεβαίωση',
  planChangeCancelledSuccessfully: 'Η αλλαγή πλάνου ακυρώθηκε με επιτυχία',
  upToDescription: '{{range}} {{seats}} {{unit}} {{productType}}.',
  pendingPlanDescription:
    'Η ενημερωμένη συνδρομή ξεκινά στις {{startingDate}}. Η συνδρομή ισχύει για {{months}} {{monthsLabel}}. Θα ανανεωθεί αυτόματα στο τέλος της περιόδου χρέωσης, εκτός αν ακυρωθεί νωρίτερα.',
  subscriptionManagedBySupport:
    'Η συνδρομή σας εξοφλείται με τραπεζικό έμβασμα και διαχειρίζεται από την ομάδα του ReportAll. Επικοινωνήστε με την υποστήριξη για αλλαγή ή ακύρωση του πλάνου σας.',
  failedToLoadBillingInformation: 'Η φόρτωση των στοιχείων χρέωσης απέτυχε',
  noBillingInformationFound: 'Δεν βρέθηκαν στοιχεία χρέωσης',
  currentPasswordIsIncorrect: 'Ο τρέχων κωδικός είναι λανθασμένος',
  currentPassword: 'Τρέχων κωδικός',
  newPassword: 'Νέος κωδικός',
  reEnterNewPassword: 'Επανάληψη νέου κωδικού',
  keepMeSignedIn: 'Να παραμείνω συνδεδεμένος',
  sort: 'Ταξινόμηση',
  allStatuses: 'Όλες οι καταστάσεις',
  allMethods: 'Όλοι οι τρόποι πληρωμής',
}
